import {
  AllowStringForNumbers,
  RecursivePartial,
  Site,
  SiteAllowStringValues,
  SiteOwnership,
  TariffConfig,
} from "@inrange/building-manager-api-client/models-site";
import { SiteCalculationsProvider } from "@inrange/shared-components";
import { Modal, ModalView } from "@inrange/theme-components";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { applySiteUpdate } from "../site/site-utils";
import ExportNetworkTariff from "../site/siteSections/ExportNetworkTariff";

const BulkEditExportNetworkTariff = ({
  selectedSiteIds,
  onSitesUpdate,
  onClose,
}: {
  selectedSiteIds: Set<string>;
  onSitesUpdate: (payload: any) => void;
  onClose: () => void;
}) => {
  const [saveNote, setSaveNote] = useState("");
  const [site, setSite] = useState<
    RecursivePartial<
      AllowStringForNumbers<{
        id: string;
        siteOwnerships: SiteOwnership[];
        tariffConfig: TariffConfig;
      }>
    >
  >({
    id: "bulk-preview",
    siteOwnerships: [],
    tariffConfig: {},
  });
  return (
    <Modal>
      <ModalView
        id="bulk-edit-export-network-tariff"
        title={`Edit Export & network tariffs for ${selectedSiteIds.size} site${selectedSiteIds.size === 1 ? "" : "s"}`}
        fontWeight="500"
        fontSize="20px"
        width="800px"
        titlePadding="0 0 10px 0"
      >
        <SiteCalculationsProvider
          site={site as unknown as Partial<Site>}
          originalSite={{}}
          app="admin"
          isBulkEdit={true}
        >
          <ExportNetworkTariff
            site={site as unknown as SiteAllowStringValues}
            setSite={(update) => {
              setSite((prevSite) => applySiteUpdate(prevSite, update));
            }}
            isBulkEdit={true}
          />
          <Form.Control
            className="mt-3"
            as="textarea"
            rows={2}
            placeholder="Add a short note describing the change made"
            value={saveNote}
            onChange={(e) => setSaveNote(e.target.value)}
            autoFocus
            data-testid="site-save-notes"
          />
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button variant="inrangesecondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={() => {
                const updates = Array.from(selectedSiteIds).reduce(
                  (acc, siteId) => {
                    acc[siteId] = {
                      // Select out only the tariffConfig part, ignoring the site ownerships
                      site: {
                        tariffConfig: site.tariffConfig || undefined,
                      },
                    };
                    if (saveNote.trim().length > 0) {
                      acc[siteId].userNote = saveNote.trim();
                    }
                    return acc;
                  },
                  {} as { [key: string]: any }
                );
                onSitesUpdate(updates);
              }}
            >
              Edit Export & network tariffs
            </Button>
          </div>
        </SiteCalculationsProvider>
      </ModalView>
    </Modal>
  );
};

export default BulkEditExportNetworkTariff;
